import { useState } from 'react';

const useFileDialog = () => {
    
    const [selectedFiles, setSelectedFiles] = useState<FileList | null>(null);

    const openFileDialog = () => {
        // console.log('OPEN FILE DIALOG!!!')
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '*/*'; // Accept all file types
        input.multiple = true;

        input.onchange = (event: Event) => {
            const target = event.target as HTMLInputElement;
            if (target.files) {
                setSelectedFiles(target.files);
            }
        };

        input.click(); // Otvori dijalog za fajlove
    };


    return {
        selectedFiles,
        openFileDialog,
    };
};

export default useFileDialog;
